import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';


@Injectable()
export class TachoService {

	private readonly mockData: any[] = [
		{
			SlotId: 1,
			Number: 1,
			Card: "0000-5554-9888-5600",
			StatValue1: "6:00",
			StatValue2: "0:19",
			StatValue3: "Brak",
			StatValue4: "0:52",
			Subjects: [
				{
					Name: "Jazda",
					Start: "8:30",
					MaxHours: 10.0,
					CurrentHours: 5.0,
				},
				{
					Name: "Praca",
					Start: "8:30",
					MaxHours: 15.0,
					CurrentHours: 5.0,
				},
			]
		},
		{
			SlotId: 2,
			Number: 2,
			Card: "4343-9036-0183-3242",
			StatValue1: "7:00",
			StatValue2: "0:21",
			StatValue3: "Brak",
			StatValue4: "2:37",
			Subjects: [
				{
					Name: "Jazda",
					Start: "9:25",
					MaxHours: 9.0,
					CurrentHours: 4.0,
				},
				{
					Name: "Praca",
					Start: "9:25",
					MaxHours: 12.0,
					CurrentHours: 10.0,
				},
			]
		},
	];

	getTachoSlotsForDriver$(driverId: number): Observable<any[]> {
		return of(this.mockData);
	}


	/**
	 *
	 */
	constructor() { }
}
